module.exports = __webpack_public_path__ + "img/openindex_hero_card.d9570610.png";